<template>
    <div id="app">
        <v-app class="main-app">
            <el-container v-if="$auth.ready()">
                <router-view></router-view>
            </el-container>
            <div v-else v-loading.fullscreen.lock="true"></div>
        </v-app>
    </div>
</template>

<script>
import {
    isMobile,
    isIOS,
    isAndroid,
    isBrowser,
    isChrome,
} from 'mobile-device-detect'

export default {
    name: 'app',

    created() {
        if (isMobile) {
            if (isIOS) {
                window.location =
                    'https://apps.apple.com/us/app/stc-mobile/id1345464444?ls=1'
            } else if (isAndroid) {
                window.location =
                    'https://play.google.com/store/apps/details?id=se.wellsec.stc.android'
            }
        }
    },

    metaInfo: {
        htmlAttrs: {
            lang: 'en',
            class: 'notranslate',
            translate: 'no',
        },
        meta: [{ name: 'google', content: 'notranslate' }],
    },
}
</script>

<style lang="scss">
@tailwind preflight;

[v-cloak] > * {
    display: none;
}

@import './../assets/scss/vendor';
@import './../assets/scss/main';

@tailwind utilities;
</style>
